<template>
    <div class="h-[80%] overflow-y-auto ">

      <div v-for="(i, index) in info" class="my-3">
          <h3 class="mb-2">
              {{ codifica_giorni[i.codifica_giorno] }}
          </h3>
          <FormInput

                  :dati='i'
                     :formlabel="label"
                     :stilestruttura="style"
                     :idform="idform"
                     :action="action"
                     :recaptcha="recaptcha"
                     :ref="'input_'+i.codifica_giorno">
          </FormInput>
      </div>
    </div>


	<div class="text-right">
		<a v-if="cancel !== ''" type="button" class="p-button p-component p-button-secondary"
			 :href="cancel">{{ bottoneannulla }}</a>
		<button @click="salvaTutti" class="p-button p-component p-button-success">
			<span class="p-button-label">{{ bottonesalva }}</span>
		</button>

	</div>
</template>

<script>

import FormInput from './FormInput.vue';

export default {
  name: "OrariForm",
  components: {
    FormInput,
  },
  props: [
    'dati',
    'struttura',
    'azione',
    'annulla',
    'stilestruttura',
    'id',
    'recaptcha',
    'bottonesalva',
    'bottonesalvacontinua',
    'bottoneannulla',
  ],
  data() {
    return {
      cancel: this.annulla,
      action: this.azione,
      info: JSON.parse(this.dati),
      label: JSON.parse(this.struttura),
      style: this.stilestruttura,
      errors: {},
      imginput: false,
      idform: this.id,
        codifica_giorni: {
          1: this.$root.trans.giorni.lunedi,
          2: this.$root.trans.giorni.martedi,
          3: this.$root.trans.giorni.mercoledi,
          4: this.$root.trans.giorni.giovedi,
          5: this.$root.trans.giorni.venerdi,
          6: this.$root.trans.giorni.sabato,
          7: this.$root.trans.giorni.domenica,
        },
    };
  },
  beforeMount() {
    if (typeof this.id == "undefined") {
      this.idform = 'maschera';
    } else {
      this.idform = this.id;
    }

  },
  mounted() {
    const thiz = this
      console.log(this.info, this.label)
    document.addEventListener('formChanged', function(e){
      this.label = e.detail.newStruttura;
      if(e.detail.newData){
        thiz.updateData(e.detail.newData)
      }
    });
  },
  methods: {
      updateData: function(newData){
        this.$refs["input"].info = newData;
        console.log(this.$refs["input"].info, newData)
      },
      async salvaTutti() {
        const results = [];
        for(let i = 1; i <= 7; i++) {
          const key = `input_${i}`;
          const inputRef = this.$refs[key][0];
          const subres = inputRef.checkForm(3);
          results.push(subres);
        }
        Promise.allSettled(results).then((res)=>{
          const errors = res.filter((r) => r.value === true)
          if (errors.length == 0) {
              this.sendForm()

          }
        })
      },
      sendForm() {
            var vm = this;
            const giorni = vm.info;
            vm.info['_token'] = document.querySelector('meta[name="csrf-token"]').getAttribute('content')
            try {
                axios.post(vm.azione, {
                    giorni: giorni,
                    _token: vm.info['_token']
                }, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                })
                    .then(function (response) {
                        if (response.data.success) {
                            this.$toast.add({
                                severity: 'success',
                                summary: this.$root.trans.success_form,
                                detail: this.$root.trans.salvataggio_success,
                                life: 3000
                            });

                            if (response.data.params) {
                                window.location.href = route(response.data.redirect, response.data.params);
                            } else {
                                window.location.href = route(response.data.redirect);
                            }

                        } else {
                            if (response.data.message != null) {
                                this.$toast.add({
                                    severity: 'errors',
                                    summary: this.$root.trans.errors_form,
                                    detail: this.$root.trans[response.data.message],
                                    life: 5000
                                });
                            } else {
                                this.$toast.add({
                                    severity: 'errors',
                                    summary: this.$root.trans.errors_form,
                                    detail: this.$root.trans.salvataggio_errato,
                                    life: 3000
                                });
                            }
                        }
                    }.bind(this));
            } catch (error) {
                if (error.response && error.response.status === 401) {
                    this.$toast.add({
                        severity: 'errors',
                        summary: this.$root.trans.errors_form,
                        detail: this.$root.trans.salvataggio_errato,
                        life: 3000
                    });
                }
            }
        }
      
  }
}
</script>

<style scoped>

</style>
